import apiClient, { SYSTEM_TOKEN } from '@shared/api/client';
import { ENDPOINTS } from '@shared/api/endpoints';
import { getStoredLanguage } from '@shared/i18n';

export const getBannerList = async () => {
  const response = await apiClient.get(ENDPOINTS.BANNER.LIST, {
    headers: { 'X-Auth-Token': SYSTEM_TOKEN },
    skipLang: true,
  });
  const isEn = getStoredLanguage() === 'en';
  return response.media.map((item) => ({
    id: item.desktop?.media_id ?? item.mobile?.media_id,
    desktopUrl: item.desktop?.cache_url || '',
    mobileUrl: item.mobile?.cache_url || '',
    title: (isEn ? item.details?.title_en : item.details?.title) || '',
    subtitle: (isEn ? item.details?.subtitle_en : item.details?.subtitle) || '',
    content: (isEn ? item.details?.content_en : item.details?.content) || '',
    url: item.url || '',
  }));
};
